<template>
  <nav class="site-navbar" :class="'site-navbar--' + navbarLayoutType">
    <iframe v-if="isIE" style="position:absolute;z-index:-1;width:100%;height:100%;top:0;left:0;right:0;bottom:0"
      allowtransparency="true" src="" frameborder="0"></iframe>
    <div class="site-navbar__header">
      <h1 class="site-navbar__brand">
        <a class="site-navbar__brand-lg" href="javascript:;">
          <!-- <span style="display: inline-block;width:35px;height:30px;"><img style="width:100%;height:100%" :src="logo"
              @error="nofoundLogo"></span> -->
          <span style="padding-left: 10px;font-size: 20px">咸宁市公共资源交易数据交换支撑平台</span>
        </a>
<!--        <a class="site-navbar__brand-mini" href="javascript:;">-->
<!--          <span style="display: inline-block;width:35px;height:30px;"><img style="width:100%;height:100%"-->
<!--              :src="systemFoldLogo" @error="nofoundLogo"></span>-->
<!--        </a>-->
      </h1>
    </div>
    <div class="site-navbar__body clearfix">
      <el-menu class="site-navbar__menu" mode="horizontal">
        <el-menu-item v-if="hasLogin" class="site-navbar__switch" index="0" @click="sidebarFold = !sidebarFold">
          <icon-svg name="zhedie"></icon-svg>
        </el-menu-item>
        <template v-if="hasLogin">
          <el-menu-item
            :class="item.id == currentAppId ? 'site-navbar__switch activedCss activedBg' : 'site-navbar__switch activedCss'"
            v-for="(item, index) in allAppList" v-if="index < menuLimitNum" :key="index" :index="'1' + index"
            @click="jumpAppXT(item)">
            <div class="titleFont">{{ item.appName }}</div>
          </el-menu-item>
          <el-menu-item v-if="allAppList.length >= menuLimitNum"
            :class="moreCode ? 'site-navbar__switch activedCss activedBg' : 'site-navbar__switch activedCss'">
            <el-dropdown>
              <span class="el-dropdown-link" style="position: relative;top:-3px;">
                {{ moreCode ? moreCode : '更多' }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="goToAppList()">
                  <span class="pull-left">应用(<span>{{ allAppList.length }}</span>)</span>&nbsp;&nbsp;
                  <span class="pull-right">全部</span>
                </el-dropdown-item>
                <template v-for="(item, index) in allAppList" v-if="index >= menuLimitNum">
                  <el-dropdown-item v-if="index == 0" :key="index" @click.native="jumpAppXT(item)"
                    divided>{{ item.appName }}</el-dropdown-item>
                  <el-dropdown-item v-else :key="index"
                    @click.native="jumpAppXT(item)">{{ item.appName }}</el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu-item>
        </template>
      </el-menu>
      <el-menu class="site-navbar__menu site-navbar__menu--right" mode="horizontal">
        <!-- <el-menu-item index="5-2"  v-if="isSupperAdmin" >
           <a v-bind:href="helpUrl" target="_blank">系统帮助</a>
        </el-menu-item> -->
        <!--        <el-submenu index="11" v-if="appList && appList.length>0">-->
        <!--          <template slot="title">{{ currentAppName }}</template>-->
        <!--          <el-menu-item   v-for="(app,index) in appList" :key="index" :index="getAppIndex(index)" @click.native="goToApp(app)">{{app.appName}}</el-menu-item>-->
        <!--        </el-submenu>-->
        <el-menu-item class="site-navbar__avatar" index="3" v-if="hasLogin" style="padding-right: 0px">

          <el-popover placement="bottom" width="500" @show="getMessageOrToDoList" trigger="hover">
            <el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick">
              <el-tab-pane name="first" :stretch="true">
                <el-badge :value="todoTotal" slot="label" :max="99" :hidden="todoTotal == 0"
                  class="tab-badge-ball">我的待办</el-badge>
                <div style="text-align: center;min-height: 100px" v-loading="todoMessageLoading">
                  <p v-if='todoTotal == 0' style="line-height: 50px">暂无待办数据</p>
                  <!--									:class="activeToDoIndex == index?'active-message':''" -->
                  <p v-for="(item, index) in todoList" :key="item.id" class="message-item" :title="item.msg"
                    @click="goToDoPage(item)"><span class="pointer"></span>{{ item.msg }}</p>
                  <el-button @click="goToDoPage('')" style="float: right" v-if="todoTotal > 6" type="text">查看更多 <i
                      class="el-icon-arrow-down el-icon--right"></i> </el-button>
                </div>
              </el-tab-pane>
              <el-tab-pane label="消息中心" name="second" :stretch="true">
                <el-badge :value="messageTotal" :max="99" slot="label" :hidden="messageTotal == 0"
                  class="tab-badge-ball">消息中心</el-badge>
                <div style="text-align: center;min-height: 100px" v-loading="todoMessageLoading">
                  <p v-if='messageTotal == 0' style="line-height: 50px">暂无消息数据</p>
                  <p v-for="(item, index) in messageList" :key="item.id" class="message-item" :title="item.msg"
                    @click="goMessagePage(item)"><span class="pointer"></span> {{ item.content }}</p>
                  <el-button type="text" v-if="messageTotal > 6 || true" style="float: right"
                    @click="goMessagePage('')">查看更多 <i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                </div>
              </el-tab-pane>
            </el-tabs>
            <!-- <el-badge :value="todoTotal + messageTotal" :max="99" :hidden="(todoTotal + messageTotal) == 0" slot="reference"
              class="badge-ball">
              <i class="el-icon-bell el-icon--right"></i>
            </el-badge> -->
          </el-popover>

          <el-dropdown :show-timeout="0" placement="bottom">
            <span class="el-dropdown-link" style="font-size: 14px">
              <img :src="userImg" style="width: 20px" alt=""> {{ displayName }}，你好
              <!--              <i class="el-icon-arrow-down"></i>-->
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item >
                <a v-bind:href="sysSettingsUrl" target="_blank">系统设置</a>
                </el-dropdown-item> -->
              <el-dropdown-item @click.native="gotoUserCenter()">用户中心</el-dropdown-item>
<!--              <el-dropdown-item @click.native="updatePasswordHandle()">修改密码</el-dropdown-item>-->
              <el-dropdown-item @click.native="logoutHandle()">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
        <el-menu-item class="site-navbar__avatar" index="3" @click.native="$router.push({ name: 'login' })"
          v-if="!hasLogin">
          登录
        </el-menu-item>
      </el-menu>
    </div>
    <!-- 弹窗, 修改密码 -->
    <update-password v-if="updatePassowrdVisible" ref="updatePassowrd"></update-password>
  </nav>
</template>

<script>
import UpdatePassword from './main-navbar-update-password';
import { logout, redirectToApp } from '@/utils/login';
import {getProjectUrl, isIEBrowser} from '@/utils/index';
import {getSetting,loadScript} from "@/utils/lui";

export default {
  data() {
    return {
      isIE: false,
      defaultLogo: require('@/assets/img/logo.png'),
      userImg: require('@/assets/img/login/user.png'),
      currentApp: [],
      helpUrl: window.SITE_CONFIG.baseUrl + '/doc.html',
      sysSettingsUrl: window.SITE_CONFIG.settingUrl,
      updatePassowrdVisible: false,
      screenWidth: document.body.clientWidth,
      menuLimitNum: 1,
      settings: window.settings,
      currentAppId: '',
      moreCode: '',//更多菜单
      appList: [], //当前用户有效访问的应用列表
      moreAppList: [], //当前用户有效访问的应用列表
      allAppList: [],
      todoList: [],
      todoTotal: 0,
      todoMessageLoading: false,
      messageList: [],
      messageTotal: 0,
      activeName: 'first',
      pmAiSrc:"",
    }
  },
  components: {
    UpdatePassword
  },
  watch: {
    /* 监听*/
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.menuTimer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.menuTimer = true
        let that = this
        setTimeout(function () {
          // 打印screenWidth变化的值
          let menuLimitNum = parseInt((val - 735) / 150);
          that.menuLimitNum = menuLimitNum <= 1 ? 1 : menuLimitNum;
          that.menuTimer = false;
        }, 400)
      }
    }
  },
  computed: {
    currentAppName: {
      get() {
        return this.currentApp && this.currentApp.appName ? this.currentApp.appName : '行政监督平台'
      }
    },
    navbarLayoutType: {
      get() { return this.$store.state.common.navbarLayoutType }
    },
    isNotProduction: {
      get() { return process !== undefined && process.env !== undefined && process.env.NODE_ENV === 'production' }
    },
    hasLogin: {
      get() { return this.$store.state.user.id !== '' && this.$store.state.user.id !== undefined }
    },
    isSupperAdmin: {
      get() { return this.$store.state.user.supperAdmin === true || this.$store.state.user.supperAdmin === 'true' }
    },
    sidebarFold: {
      get() { return this.$store.state.common.sidebarFold },
      set(val) { this.$store.commit('common/updateSidebarFold', val) }
    },
    topNavIndex: {
      get() { return this.$store.state.common.topNavIndex },
      set(val) { this.$store.commit('common/updateTopNavIndex', val) }
    },
    mainTabs: {
      get() { return this.$store.state.common.mainTabs },
      set(val) { this.$store.commit('common/updateMainTabs', val) }
    },
    userName: {
      get() { return this.$store.state.user.name }
    },
    systemFoldLogo: {
      get() {
        let logo = this.settings.system_fold_logo
        if (!logo) {
          logo = this.defaultLogo
        }
        return logo
      }
    },
    logo: {
      get() {
        let logo = this.settings.system_logo
        if (!logo) {
          logo = this.defaultLogo
        }
        return logo
      }
    },
    displayName: {
      get() {
        var username = this.$store.state.user.displayName
        if (username === '') {
          username = '游客'
        }
        return username
      }
    },
    userinfo: {
      get() {
        return this.$store.state.user.userinfo
      }
    },
  },
  created() {
    this.currentAppId = process.env.VUE_APP_appId
    this.appidPrefix = process.env.VUE_APP_appId
    this.loadStaticConf()
    this.loadAppData()
    let menuLimitNum = parseInt((this.screenWidth - 735) / 150);
    this.menuLimitNum = menuLimitNum <= 1 ? 1 : menuLimitNum;
    this.isIE = isIEBrowser();


  },

  mounted() {
    this.getMessageAndToDoTotal();

  },
  methods: {
    goToDoPage(item) {
      if(item){
        let appList = sessionStorage.getItem("appList") &&  JSON.parse(sessionStorage.getItem("appList")) || [];
        let appId = item.appId;
        let filters = appList.filter((item) => item.id == appId);
        if (filters.length > 0) {

          // this.$router.push({
          //   path: '/userTask'
          // });
          setTimeout(()=>{  //  FIXME 解决测试环境首页待办跳转详页流程图打开错乱问题，给个延迟确保该页面被activated
            // $tabsUtils?.removeTab('dynamic_待办跳转');

            this.$nextTick(() => {
              this.routerTo(item)
              //  integrateType  0 = 内部模块  1=代理模块 2=微应用 9=外部系统  99 = 系统配置
              // if(item.integrateType == 0 || item.integrateType == 9){
              //   this.$router.push({
              //     path: getProjectUrl(item.field1)
              //   })
              // }
              // if(item.integrateType == 1){
              //   var src =  '/proxy' + item.appId + (item.url.indexOf('/') == 0?item.url:( '/' + item.url));
              //   // $tabsUtils?.addPanel('待办跳转', src, '')
              //     window.open(src)
              // }

            })
          },500)
        }else{
          this.$message.error('您无权限跳转对应页面。')
        }

      }else{
        this.$router.push({
          path: '/userTask'
        });
      }


    },
    gotoUserCenter() {
      window.open(`${process.env.VUE_APP_suiteUrl}/userCenter?token=${this.$cookie.get('access_token')}`)
    },
    goMessagePage(item) {
      if (item) {
        this.handleUpdateReadStatus(item.id);
      } else {
        this.$router.push({
          path: '/messagelist'
        });
      }
    },
    getMessageAndToDoTotal() {
      if (this.notifyTipsDisable === true) {
        return
      }
      this.$http.post('/userTask/totals', {}, { baseURL: '/proxyhome' }).then((res) => {
        if (res.status == 200) {
          this.todoTotal = !isNaN(res.data) ? res.data : 0;
        }
      })
      this.$http.post('/basic/msg/logTotal', {
        'filter': {
          receiveUserId: this.userinfo?.userId,
          receiveUser: this.isSupperAdmin ? 'supperadmin' : null,
          status: '1',
        }
      }, {
        baseURL: '/sso'
      }).then(({ data }) => {
        if (data && data.code == '1') {
          this.messageTotal = !isNaN(data.data) ? data.data : 0;
        } else {
          this.messageTotal = 0;
        }
      })
    },
    handleClick() {
      this.getMessageOrToDoList();
    },
    getMessageOrToDoList() {
      if (this.activeName == 'first') {
        this.getTodoList();
      } else {
        this.getMessageList();
      }
    },
    getTodoList() {

      this.todoMessageLoading = true;
      this.$http.post('/userTask/list', {
        'page': 1,
        'rows': 6,
        'searchKey': '',
        'filter': {}
      }, { baseURL: '/proxyhome' }).then(res => {
        this.todoMessageLoading = false;
        if (res.data) {
          this.todoList = res.data.rows || [];
          this.todoTotal = res.data.total || 0;
        } else {
          this.todoList = 0;
        }
      })
    },
    getMessageList() {

      let url = '/basic/msg/logList'
      let params = {
        'page': 1,
        'rows': 6,
        'searchKey': '',
        'filter': {
          receiveUserId: this.userinfo.userId,
          receiveUser: this.isSupperAdmin ? 'supperadmin' : null,
          status: '1',
        }
      }
      this.todoMessageLoading = true;
      this.$http.post(url, params, {
        baseURL: '/sso'
      }).then(({ data }) => {
        this.todoMessageLoading = false;
        if (data) {
          this.messageList = data.rows;
          this.messageTotal = data.total;
        } else {
          this.messageList = [];
          this.messageTotal = 0;
        }
      })
    },

    nofoundLogo(event) {
      let img = event.srcElement
      img.src = this.defaultLogo
      img.onerror = null
    },
    isCurrentApp(item) {
      // item.id == this.currentAppId 兼容旧格式
      return item.id == this.currentAppId || item.id.startsWith(this.appidPrefix)
    },
    jumpAppXT(item) {//跳转系统获取菜单
      if(item.name === '远程监控鸟瞰大屏') {
            window.open( (process.env.VUE_APP_largescreen || "/largescreen/#/live"), "bigdata")
            return;
        }


      if (this.isCurrentApp(item)) {
        // 加载二级菜单
        // 同应用跳转
        // this.$store.commit('common/updateMenuList', JSON.stringify(data.menuList || '[]'))
        const menuList = JSON.parse(sessionStorage.getItem('menuList') || '[]')
        // 通过item.id获取对应的菜单
        const menu = menuList.find(menu => `${this.appidPrefix}_${menu.menuId}` == item.id)
        if (menu) {
          this.$bus.$emit('updateMenuList', menu.list)
          this.currentAppId = item.id
        }
        return
      } else if (item.basePath) {
        const token = this.$cookie.get('access_token')
        const filterAppIds = process.env.VUE_APP_filterAppIds || '';
        const filterAppIdsArr = filterAppIds.split(',');
        // 交换云脑强行兼容
        if(filterAppIdsArr.indexOf(item.id) === 3){
          window.open(`${item.basePath}?appId=${item.id}&token=${token}`)
          return
        }
        window.location.href = `${item.basePath}?appId=${item.id}&token=${token}`
      } else {
        window.location.href = process.env.VUE_APP_suiteUrl
      }

    },
    goToAppList() {
      window.location.href = (process.env.VUE_APP_suiteUrl || '') + '/apps/select'
      // this.$router.push({name:"app-select"})
    },
    getAppIndex(index) {
      return "11-" + index
    },
    goToApp(app) {
      redirectToApp(app)
    },
    selectTopNav(index) {
      this.topNavIndex = index
      console.log(index, this.topNavIndex, 'this.topNavIndex')
    },
    // 修改密码
    updatePasswordHandle() {
      this.updatePassowrdVisible = true
      this.$nextTick(() => {
        this.$refs.updatePassowrd.init();
        this.iframeInsert(this.$el);
      })
    },
    // 退出
    logoutHandle() {
      sessionStorage.removeItem("roleUserType");
      this.$confirm(`确定进行[退出]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout()
      })
    },
    loadStaticConf() {
      this.settings = getSetting();
      this.$nextTick(()=>{
        this.initPmai()
      })
    },
    initPmai(){
      let setting = getSetting();
      if(!setting.isShowAiChat){
        return
      }
      if(!this.hasLogin){
        return
      }
      if(this.pmAiSrc !== ''){
        return
      }
      if(!this.hasBtnPermission("pm-aichat-btn")){
        return
      }
      let robotPath = setting.aichatBtnBgUrl || '';
      let aichatSrc = setting.aichat || '';
      if(aichatSrc && aichatSrc){
        this.pmAiSrc = aichatSrc
        loadScript(aichatSrc, function () {
          embedChatbot()
        },{"id":"pm-chat-script","data-params":"{enlarge:false,largeWidth:'50%',smallWidth:'25%',btnImgUrl:'"+robotPath+"'}"})
      }

    },
    loadAppData() {
      let url = '/auth/application/selectAppList';
      this.$http({
        url: url,
        method: 'post',
        data: {
          tradeOrgId: process.env.VUE_APP_tradeOrgId,
          menuEnable:false, // 传true的时候，查询的头部数据不包含一级菜单，默认是false
        },
        baseURL: '/sso',
      }).then(({ data }) => {
        // this.allAppList = data;
        let filterAppIds = process.env.VUE_APP_filterAppIds || '';
        // appId 或者 appId_menuId 都可以匹配到filterAppIds
        data.forEach(item=>{
          const id = item.id;
          const idArr = id.split('_');
          const pid = idArr[0];
          if(filterAppIds.indexOf(pid) > -1){
            this.allAppList.push(item);
          }
        })
        // this.allAppList = data.filter(item=>filterAppIds.some(id => ));

        let menuId = this.$route.query.menuId || '';
        if(menuId){
          let filter = this.allAppList.filter((item, index) => {
            return item.id.indexOf(menuId) > -1
          })
          filter[0]?this.jumpAppXT(filter[0]):this.jumpAppXT(this.allAppList[0])
          return
        }
        this.jumpAppXT(this.allAppList[0])

      })
    }
  }
}
</script>
<style lang="less" scoped>


.site-navbar{
		/deep/ .badge-ball{
			position: relative;
			top: -3px;
			margin-right:24px;
			.is-fixed{
				top:5px;
				right:13px;
			}
		}
	}
	/deep/ .tab-badge-ball{
		.is-fixed{
			top: 14px;
			right: 0px;
		}
	}
.site-navbar__menu {
  .activedCss {
    // color: rgba($color: #ffffff, $alpha: 0.8) !important;
    color: rgba(255, 255, 255, 0.8) !important;
  }

  .activedBg,
  .activedCss:hover {
    background-color: transparent !important;
    color: #ffffff !important;
  }

  .activedBg {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 4px;
      background-color: #1890FF;
    }
  }
}
.message-item{
  line-height: 26px;
  text-align: left;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space:nowrap;
  overflow: hidden;
  &:hover{
    color:#1890FF;
    .pointer{
      background: #1890FF;
    }
  }
}
/*.site-navbar--inverse .el-menu > .el-menu-item:hover{*/
/*  background-color: #1965FF;*/
/*}*/
/*  .el-menu.el-menu--horizontal{*/
/*    border-bottom: none;*/
/*  }*/

/*  .el-menu-item, .el-submenu > .el-submenu__title {*/
/*    height: 50px;*/
/*    line-height: 50px;*/
/*  }*/

/*  .site-navbar--inverse .el-menu > .el-menu-item.is-active, .site-navbar--inverse .el-menu > .el-submenu.is-active > .el-submenu__title{*/
/*    background-color: #1965FF;*/
/*  }*/

/*  .site-navbar__menu.el-menu--horizontal{*/
/*    border-bottom: none;*/

/*  }*/
/*  !*.el-menu--horizontal>.el-menu-item{*!*/
/*  !*  height: 50px;*!*/
/*  !*  line-height: 50px;*!*/
/*  !*}*!*/

/*.site-navbar__menu{*/
/*  background-color:#1965FF;*/
/*}*/


/*  .site-navbar__brand{*/
/*    text-align: left;*/
/*    padding-left: 20px;*/
/*  }*/
</style>